import React, { useCallback, useEffect, useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import Header from "../components/Header";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContentText,
  Slide,
  TextField,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PatientStatus from "../components/PatientStatus";
import Patientinfo from "../components/Patientinfo";
import LeftNav from "../components/LeftNav";
import Setting from "../components/Setting";
import { Pagination } from "@material-ui/lab";
import axios from "axios";
import { apiAxios, sdkWrapperURL } from "../Util/ApiAxios";
import { BiXCircle } from "react-icons/bi";
import Loader from "react-loader-spinner";
import Select from "react-dropdown-select";

const InvitePatient = () => {
  const classes = useStyles();
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState(false);
  const [patientList, setPatientList] = useState([]);
  const [showLoader, setShowLoader] = React.useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [message, setMessage] = useState("");
  const [packages, setPackages] = useState([]);
  const [selectedPackageId, setSelectedPackageId] = useState("");
  const [packageError, setPackageError] = useState("");

  const validatePhone = (phone) => {
    const phoneRegex = /^\d{10}$/;
    return phoneRegex.test(phone);
  };

  useEffect(() => {
    apiAxios
      .post(
        "/client/list/packages",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("dhct_Token"),
          },
        }
      )
      .then((response) => {
        if (
          response.data.statusCode === 200 &&
          Array.isArray(response.data.body)
        ) {
          setPackages(response.data.body);
        } else {
          console.warn("Unexpected response:", response.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching packages:", error);
      });
  }, []);

  const invite = async () => {
    console.log("clicked");
    let isValid = true;

    if (!phone || !validatePhone(phone)) {
      setPhoneError(true);
      isValid = false;
    }

    if (!password || password.trim().length === 0) {
      setPasswordError(true);
      isValid = false;
    }
    if (!selectedPackageId || selectedPackageId.trim().length === 0) {
      setPackageError(true);
      isValid = false;
    }

    if (isValid) {
      setShowLoader(true);

      const data = {
        api_key: "CNCPaIxRn39Rlp7NlZ6y",
        resource_id: "5a8cffe6-1a16-415e-87a2-e9a63ec0bd26",
        username: phone,
        password,
        subscribed_package_id: selectedPackageId,
      };

      try {
        const response = await axios.post(
          sdkWrapperURL("/auth/user-onboard"),
          data
        );
        if (response.data.statusCode === 200) {
          toast.success(response.data.message, {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          getPatientList();
        } else {
          toast.error(response.data.message, {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      } catch (error) {
        console.error("Error:", error);
        alert("Failed to invite patient. Please try again.");
      } finally {
        setPhone("");
        setPhoneError("");
        setPassword("");
        setPasswordError("");
        setSelectedPackageId("");
        setShowLoader(false);
      }
    }
  };

  const getPatientList = useCallback(
    async ({
      table_config_rows_per_page = "15",
      table_config_page_no = "1",
    } = {}) => {
      setCurrentPage(parseInt(table_config_page_no));

      setPatientList([]);
      setMessage("Loading...");

      let data = {
        table_config_page_no: table_config_page_no,
        table_config_rows_per_page: table_config_rows_per_page,
      };

      apiAxios
        .post("/client/user-referral-list", data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("dhct_Token"),
          },
        })
        .then((response) => {
          console.log("response --> ", response);
          if (response.data.statusCode == 200) {
            setPatientList(response.data.response);
            setMessage("");
            setTotalPages(response.data.total_pages);
          } else if (response.data.statusCode == 502) {
            setMessage("No Data Found");
          } else {
            // toast.error(response.data.message, {
            //     position: "bottom-center",
            //     autoClose: 5000,
            //     hideProgressBar: false,
            //     closeOnClick: true,
            //     pauseOnHover: true,
            //     draggable: true,
            //     progress: undefined,
            //     });

            setMessage(response.data.message);
          }
        })
        .catch((error) => {
          console.log(error);

          // toast.error(error.message, {
          //     position: "bottom-center",
          //     autoClose: 5000,
          //     hideProgressBar: false,
          //     closeOnClick: true,
          //     pauseOnHover: true,
          //     draggable: true,
          //     progress: undefined,
          //     });

          localStorage.removeItem("dhct_Refresh_Token");
          localStorage.removeItem("dhct_Token");
          // window.location.href = "/";
        });
    },
    []
  );
  useEffect(() => {
    getPatientList();
  }, []);
  return (
    <div>
      {/* <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      /> */}

      <Header />
      <Box className={classes.Pagecontent}>
        <Box className={classes.Leftcol}>
          <Box className={classes.leftnav} style={{ marginTop: "40px" }}>
            {localStorage.getItem("dhct_JWT") ? <PatientStatus /> : <></>}
          </Box>
        </Box>
        <Box className={classes.Rightcol}>
          <Box className={classes.Searchresult}>
            <Box className={classes.Topfilter}>
              <Box
                className={classes.FilterSearchCol}
                style={{ marginRight: 15 }}
              >
                <label>
                  Contact Patient <span style={{ color: "#ff0000" }}>*</span>
                </label>
                <TextField
                  className={classes.input}
                  placeholder="Patient Phone Number"
                  type="tel"
                  value={phone}
                  onChange={(e) => {
                    const numericValue = e.target.value.replace(/\D/g, "");
                    if (numericValue.length <= 10) {
                      setPhone(numericValue);
                    }
                  }}
                  autoComplete="new-password"
                  inputProps={{
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                    maxLength: 10,
                  }}
                />
                {phoneError ? (
                  <p
                    style={{
                      color: "#dc3545",
                      fontSize: ".875em",
                      marginTop: "0.25rem",
                      width: "100%",
                      textAlign: "right",
                    }}
                  >
                    Please enter valid phone number.
                  </p>
                ) : (
                  <></>
                )}
              </Box>

              <Box
                className={classes.FilterSearchCol}
                style={{ marginRight: 15 }}
              >
                <label>
                  Select Package Type<span style={{ color: "#ff0000" }}>*</span>
                </label>
                <Select
                  options={packages}
                  values={
                    selectedPackageId
                      ? packages.filter(
                          (pkg) => pkg.package_id === selectedPackageId
                        )
                      : []
                  }
                  onChange={(values) => {
                    if (values && values.length > 0) {
                      const selected = values[0];
                      if (selected && selected.package_id) {
                        setSelectedPackageId(selected.package_id);
                      } else {
                        setSelectedPackageId("");
                      }
                    }
                  }}
                  className={classes.select}
                  labelField="package_name"
                  valueField="package_id"
                  placeholder="Select Package Type"
                  dropdownHandle
                  clearable={false}
                />
                {packageError ? (
                  <p
                    style={{
                      color: "#dc3545",
                      fontSize: ".875em",
                      marginTop: "0.25rem",
                      width: "100%",
                      textAlign: "right",
                    }}
                  >
                    Package type cannot be blank.
                  </p>
                ) : (
                  <></>
                )}
              </Box>

              <Box
                className={classes.FilterSearchCol}
                style={{ marginRight: 15 }}
              >
                <label>
                  Password<span style={{ color: "#ff0000" }}>*</span>
                </label>
                <TextField
                  className={classes.input}
                  placeholder="Password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="new-password"
                />
                {passwordError ? (
                  <p
                    style={{
                      color: "#dc3545",
                      fontSize: ".875em",
                      marginTop: "0.25rem",
                      width: "100%",
                      textAlign: "right",
                    }}
                  >
                    Password cannot be blank.
                  </p>
                ) : (
                  <></>
                )}
              </Box>

              <Button className={classes.Searchbtn} onClick={invite}>
                Invite
              </Button>
            </Box>
            <h3 className={classes.Toptext} style={{ textAlign: "left" }}>
              Invited Patients List
            </h3>

            <Box className={classes.PatientListTable}>
              <Box className={classes.throw}>
                <Box className={classes.provider}>Contact No.</Box>
                <Box className={classes.firstname}>Invitation Timestamp</Box>
                <Box className={classes.firstname}>Registration Timestamp</Box>
                <Box className={classes.firstname}>Last Updated Timestamp</Box>
                <Box className={classes.lastname}>Registration Status</Box>
              </Box>
              {patientList.length > 0 ? (
                <>
                  {patientList.map((each) => (
                    <Box className={classes.tdrow}>
                      <Box className={classes.provider}>
                        {each.phone_number}
                      </Box>
                      <Box className={classes.firstname}>
                        {each?.invitation_date
                          ? new Date(each?.invitation_date).toLocaleString(
                              "en-IN",
                              {
                                timeZone: "Asia/Kolkata",
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                              }
                            )
                          : "—"}
                      </Box>
                      <Box className={classes.firstname}>
                        {each?.registration_date
                          ? new Date(each?.registration_date).toLocaleString(
                              "en-IN",
                              {
                                timeZone: "Asia/Kolkata",
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                              }
                            )
                          : "—"}
                      </Box>
                      <Box className={classes.firstname}>
                        {each?.last_updated
                          ? new Date(each?.last_updated).toLocaleString(
                              "en-IN",
                              {
                                timeZone: "Asia/Kolkata",
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                              }
                            )
                          : "—"}
                      </Box>
                      <Box className={classes.lastname}>{each.status}</Box>
                    </Box>
                  ))}
                </>
              ) : (
                <Box style={{ marginTop: "30px", textAlign: "center" }}>
                  {message}
                </Box>
              )}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "right",
                  justifyContent: "right",
                }}
              >
                <Pagination
                  count={totalPages}
                  color="primary"
                  page={currentPage}
                  onChange={(event, pageNumber) =>
                    getPatientList({
                      table_config_page_no: `${pageNumber}`,
                      list_type: "upcoming",
                    })
                  }
                />
              </div>
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default InvitePatient;

const useStyles = makeStyles(() => ({
  Pagecontent: {
    width: "100%",
    display: "flex",
    textAlign: "left",
  },
  leftnav: {
    position: "absolute",
    top: "15px",
    bottom: "15px",
    left: "40px",
    right: "40px",
    "@media only screen and (max-width: 1200px)": {
      left: "20px",
      right: "20px",
    },
  },
  Leftcol: {
    width: "15%",
    padding: "20px 3%",
    position: "relative",
    minHeight: "800px",
    background: "linear-gradient(45deg, #114ebd, #0f3d6e)",
    "@media only screen and (max-width: 1200px)": {
      width: "24%",
      padding: "20px 1%",
    },
    "@media only screen and (max-width: 820px)": {
      width: "98%",
      padding: "20px 1%",
      position: "absolute",
      background: "none",
      minHeight: 25,
    },
    "@media only screen and (max-width: 768px)": {
      width: "98%",
      padding: "20px 1%",
      position: "absolute",
      background: "none",
      minHeight: 25,
    },
  },
  Rightcol: {
    width: "75%",
    padding: "20px 2%",
    borderLeft: "1px #F6F6F6 solid",
    "@media only screen and (max-width: 820px)": {
      width: "96%",
      padding: "0 2%",
      marginTop: 30,
    },
    "@media only screen and (max-width: 768px)": {
      width: "96%",
      padding: "0 2%",
      marginTop: 30,
    },
    "& .MuiAccordionSummary-root": {
      borderBottom: "1px #5f80a9 solid",
      height: "40px",
      color: "#bfc4cb",
      padding: "0px",
      fontFamily: "Poppins",
    },
    "& .MuiAccordion-root:before": {
      display: "none",
    },
    "& .MuiTab-root": {
      minWidth: "33%",
    },
    "& .MuiTab-root:nth-child(6)": {
      minWidth: "30%",
    },
    "& .MuiTab-root:nth-child(7)": {
      minWidth: "30%",
    },
  },
  FilterSearchCol: {
    width: "30%",
    "@media only screen and (max-width: 1200px)": {
      width: "30.5%",
    },
    "@media only screen and (max-width: 820px)": {
      width: "45.5%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "45.5%",
    },
  },
  PatientListTable: {
    width: "100%",
    "@media only screen and (min-device-width: 768px) and (max-device-width: 1200px)":
      {
        overflowX: "auto",
      },
  },
  throw: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "2px #E3E5E5 solid",
    fontSize: "14px",
    color: "#fff",
    paddingBottom: "5px",
    background: "linear-gradient(to left, #114ebd, #0f3d6e)",
    // padding: 6,
    padding: "10px 10px",
    "@media only screen and (min-device-width: 768px) and (max-device-width: 1200px)":
      {
        width: 1366,
      },
  },
  tdrow: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px #E3E5E5 solid",
    fontSize: "14px",
    // padding: "10px 0",
    padding: "10px 10px",
    "@media only screen and (min-device-width: 768px) and (max-device-width: 1200px)":
      {
        width: 1366,
      },
  },
  providerbtn: {
    display: "flex",
    cursor: "pointer",
    "& span": {
      display: "flex",
      flexDirection: "column",
      width: "20px",
      marginRight: "10px",
      "& button": {
        background: "none",
        border: "none",
        height: "10px",
        cursor: "pointer",
      },
    },
  },
  provider: {
    width: "11%",
    textAlign: "left",
    paddingRight: 5,
    paddingLeft: 5,
    fontFamily: "poppins",
    fontSize: 14,
  },
  firstname: {
    width: "12%",
    textAlign: "left",
    wordWrap: "break-word",
    overflow: "auto",
    paddingRight: 5,
    fontFamily: "poppins",
    fontSize: 14,
  },
  lastname: {
    width: "12%",
    textAlign: "left",
    wordWrap: "break-word",
    overflow: "auto",
    paddingRight: 5,
    fontFamily: "poppins",
    fontSize: 14,
  },
  dob: {
    width: "12%",
    textAlign: "left",
    paddingRight: 5,
    fontFamily: "poppins",
    fontSize: 14,
  },
  // emrID:{
  //     width:'5%',
  //     textAlign:'left'
  // },
  hrpmID: {
    width: "8%",
    textAlign: "left",
    paddingRight: 5,
    fontFamily: "poppins",
    fontSize: 14,
  },
  emrID: {
    width: "11%",
    textAlign: "left",
    wordWrap: "break-word",
    paddingRight: 5,
    fontFamily: "poppins",
    fontSize: 14,
  },
  status: {
    width: "8%",
    paddingRight: 5,
    fontFamily: "poppins",
    fontSize: 14,
    // textAlign:'center'
  },
  phone: {
    width: "12%",
    textAlign: "left",
    paddingRight: 5,
    fontFamily: "poppins",
    fontSize: 14,
  },
  program: {
    width: "10%",
    textAlign: "left",
    cursor: "pointer",
    paddingRight: 5,
    fontFamily: "poppins",
    fontSize: 14,
  },
  date: {
    width: "12%",
    textAlign: "center",
    paddingRight: 5,
    fontFamily: "poppins",
    fontSize: 14,
  },
  agentID: {
    width: "15%",
    textAlign: "left",
    paddingRight: 5,
    fontFamily: "poppins",
    fontSize: 14,
  },
  finaldate: {
    width: "15%",
    textAlign: "left",
    paddingRight: 5,
    fontFamily: "poppins",
    fontSize: 14,
  },
  plan: {
    width: "15%",
    textAlign: "left",
    paddingRight: 5,
    fontFamily: "poppins",
    fontSize: 14,
  },
  actionHead: {
    width: "10%",
    textAlign: "left",
    paddingRight: 5,
    fontFamily: "poppins",
    fontSize: 14,
  },
  action: {
    width: "10%",
    textAlign: "left",
    overflow: "scroll",
    fontFamily: "poppins",
    fontSize: 14,
  },
  Toptext: {
    fontSize: 20,
    marginTop: 0,
    fontWeight: "600",
    fontFamily: "Poppins",
    color: "#121212",
  },
  Searchresult: {
    "& h4": {
      fontSize: "16px",
      color: "#0f3d6e",
      fontWeight: "500",
      margin: "40px 0",
      textAlign: "left",
    },
  },
  Topfilter: {
    width: "100%",
    display: "flex",
    marginTop: 30,
    marginBottom: 50,
    flexDirection: "row",
    "@media only screen and (min-device-width: 768px) and (max-device-width: 1200px)":
      {
        flexWrap: "wrap",
      },
    "& label": { color: "#666", marginBottom: 5, display: "flex" },
    "& .MuiInput-underline:before": {
      display: "none",
    },
    "& .MuiInput-underline:after": {
      display: "none",
    },
    "& .MuiInput-formControl": {
      height: "50px",
    },
    "& .MuiInput-input:focus": {
      border: "1px #0074D9 solid",
      boxShadow: "2px 2px 10px 1px rgba(0,0,0,0.3)",
    },
    "& .MuiInputBase-input": {
      height: "50px",
      borderRadius: "10px",
      border: "1px #D5D5D5 solid",
      backgroundColor: "#F9F9F9",
      padding: "0 15px",
    },
    "& .MuiTextField-root": {
      width: "100%",
    },
  },
  Searchbtn: {
    background: "#0f3d6e",
    borderRadius: 10,
    display: "flex",
    color: "#fff",
    height: 50,
    paddingLeft: 30,
    paddingRight: 30,
    marginLeft: 10,
    textTransform: "capitalize",
    marginTop: 28,
    "@media only screen and (max-width: 820px)": {
      marginLeft: 15,
    },
    "@media only screen and (max-width: 768px)": {
      marginLeft: 15,
    },
    "&:hover": {
      background: "rgba(0,0,0,0.8)",
    },
  },
  select: {
    width: "100% !important",
    border: "none !important",
    borderRadius: "10px !important",
    background: "#F9F9F9",
    height: "50px",
    fontSize: "14px !important",
    paddingLeft: "15px !important",
    paddingRight: "15px !important",
  },
}));
